export {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
	AlertDialogPrimitiveAction,
} from "ics-ui-kit/components/alert-dialog";
export { AlertDialogIcon } from "./AlertDialogIcon";
